import { convertDateToISOString, setCurrencyFormat } from 'src/utils/util';
import { getPriceInNumberDataType } from './dataModificaionUtil';
import { checkImpersonationActive, checkProxyActive } from 'src/utils/util';
import {
    CONSIGNMENT_RETURN_MANDATORY_FIELDS,
    CONSIGNMENT_USER_MANDATORY_FIELDS,
} from 'src/constants/appConstants';
import i18n from 'src/i18n';

export const isPriceOverrideApplyBtnDisabled = (
    priceOverrideReason,
    priceOverrideTableData
) => {
    return (
        (priceOverrideReason && priceOverrideReason.length > 0
            ? !priceOverrideTableData.some(
                  (item) =>
                      item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice
              )
            : false) ||
        (priceOverrideTableData.some(
            (item) =>
                !item.invalidOtherQtyAdjBasePriceMsg &&
                !item.invalidUsedQtyAdjBasePriceMsg &&
                (item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice)
        )
            ? !(priceOverrideReason && priceOverrideReason.length > 0)
            : false) ||
        priceOverrideTableData.some(
            (item) =>
                item.invalidOtherQtyAdjBasePriceMsg ||
                item.invalidUsedQtyAdjBasePriceMsg
        )
    );
};
export const getModifiedButtonVisibilities = (
    footerButtonStatuses,
    btn1,
    btn2,
    fromProgressBar
) => {
    let modifiedButtonStatuses = [...footerButtonStatuses];
    if (fromProgressBar) {
        modifiedButtonStatuses = modifiedButtonStatuses.map((x) =>
            x.btnName !== i18n.t('reportUsage.common.cancel') &&
            x.btnName !== i18n.t('reportUsage.saveExit')
                ? { ...x, btnVisibility: false }
                : x
        );
    }
    const btn1Idx = modifiedButtonStatuses.findIndex((x) => x.btnName === btn1);
    if (btn1Idx >= 0) {
        modifiedButtonStatuses[btn1Idx].btnVisibility = false;
    }
    const saveExitBtnIdx = modifiedButtonStatuses.findIndex(
        (x) => x.btnName === i18n.t('reportUsage.saveExit')
    );
    modifiedButtonStatuses[saveExitBtnIdx].btnVisibility =
        btn2 === i18n.t('productGuide.productGuideFilter.apply') ? false : true;
    const btn2Idx = modifiedButtonStatuses.findIndex((x) => x.btnName === btn2);
    if (btn2Idx >= 0) {
        modifiedButtonStatuses[btn2Idx].btnVisibility = true;
    }
    return modifiedButtonStatuses;
};

export const calculateDiscountPercentage = (originalPrice, adjustedPrice) => {
    const discount =
        originalPrice > 0 ? (originalPrice - adjustedPrice) / originalPrice : 0;
    return (discount * 100).toFixed(2);
};

export const checkIfValidQuantities = (qty) => {
    const usedQty =
        (qty.used && qty.used.toString()) || (qty.Used && qty.Used.toString());
    const onHandQty = qty.onHand && qty.onHand.toString();
    if (parseInt(usedQty) > parseInt(onHandQty)) {
        return false;
    } else if (!onHandQty && parseInt(usedQty) > 0) {
        return true;
    } else if (parseInt(usedQty) < 0) {
        return false;
    } else if (!usedQty && !usedQty) {
        return false;
    } else {
        return true;
    }
};

export const checkIfValidPricedItems = (itemTableData) =>
    itemTableData &&
    itemTableData.length > 0 &&
    itemTableData.every((item) =>
        !item.isInvalidItemMsg &&
        getPriceInNumberDataType(item.basePrice) >= 0 &&
        item.lotSerial &&
        item.lotSerial.length > 0 &&
        item.lotSerial.every(
            (qty) =>
                !qty.isInvalidLotSerialMsg &&
                !qty.isInvalidQtyMsg &&
                checkIfValidQuantities(qty)
        ) &&
        item.isBundleItem
            ? item.children &&
              item.children.length > 0 &&
              item.children.every(
                  (child) =>
                      !child.isInvalidItemMsg &&
                      child.lotSerial &&
                      child.lotSerial.length > 0 &&
                      child.lotSerial.every(
                          (qty) =>
                              !qty.isInvalidLotSerialMsg &&
                              !qty.isInvalidQtyMsg &&
                              checkIfValidQuantities(qty)
                      )
              )
            : !item.children
    );

export const getTotalUsedQuantity = (lotSerialArr) => {
    const usedQuantityArr =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr
            .map((x) => {
                const usedQty = x.used || x.Used;
                return usedQty === true ? 1 : parseInt(usedQty);
            })
            .filter((y) => !isNaN(parseInt(y)));
    return usedQuantityArr && usedQuantityArr.length > 0
        ? usedQuantityArr.reduce((a, b) => a + b, 0)
        : null;
};

export const getTotalUsedTissueItemQuantity = (lotSerialArr) => {
    const usedQuantity =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr.filter((x) => x.used === true || x.Used === true);
    return usedQuantity && usedQuantity.length;
};

export const getTotalOtherTissueItemQuantity = (lotSerialArr) => {
    const otherQuantity =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr.filter((x) => x.other === true || x.Other === true);
    return otherQuantity && otherQuantity.length;
};

export const getTotalOtherQuantity = (lotSerialArr) => {
    const otherQuantityArr =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr
            .map((x) => {
                const otherQty = x.other || x.Other;
                return otherQty === true ? 1 : parseInt(otherQty);
            })
            .filter((y) => !isNaN(parseInt(y)));
    return otherQuantityArr && otherQuantityArr.length > 0
        ? otherQuantityArr.reduce((a, b) => a + b, 0)
        : null;
};

export const getTotalQuantity = (lotSerialArr) => {
    let totalQuantity = 0;
    if (lotSerialArr && lotSerialArr.length > 0) {
        const usedQuantity = getTotalUsedQuantity(lotSerialArr)
            ? getTotalUsedQuantity(lotSerialArr)
            : 0;
        const otherQuantity = getTotalOtherQuantity(lotSerialArr)
            ? getTotalOtherQuantity(lotSerialArr)
            : 0;
        totalQuantity = usedQuantity + otherQuantity;
    }
    return totalQuantity;
};

export const numFormatObj = {
    style: 'currency',
    currency: localStorage.getItem('currencyISOCode'),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export const getTotalExtendedPrice = (adjBasePrice, lotSerialArr, qtyType) => {
    let extendedPrice = setCurrencyFormat(0),
        quantity = 0;
    if (qtyType === 'used') {
        quantity = getTotalUsedQuantity(lotSerialArr);
    } else if (qtyType === 'other') {
        quantity = getTotalOtherQuantity(lotSerialArr);
    } else if (qtyType === 'total') {
        quantity = getTotalQuantity(lotSerialArr);
    }
    if (adjBasePrice && quantity > 0) {
        extendedPrice = setCurrencyFormat(
            parseFloat(getPriceInNumberDataType(adjBasePrice)).toFixed(2) *
                quantity
        );
    }
    return adjBasePrice ? extendedPrice : '';
};

export const flattenLotSerialArrayOfArrays = (filterType, items) => {
    if (filterType === 'nonTissue') {
        return items
            .filter((item) => item.salesOrg === 'S002')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'tissue') {
        return items
            .filter((item) => item.salesOrg === 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'accOwned') {
        return items
            .filter((item) => item.accountOwned)
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    }
    return [];
};

export const checkIfValidProductsInRecordScreen = (
    validProducts,
    itemTableData,
    patientDetails
) => {
    const validProductsCfn = validProducts.map((x) => x.productCFN);
    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every((item) =>
            !item.isInvalidItemMsg &&
            validProductsCfn.includes(item.cfn) &&
            item.lotSerial.every(
                (x) => x.isInvalidLotSerialMsg === null && !x.isInvalidQtyMsg
            ) &&
            item.isBundleItem
                ? item.children &&
                  item.children.every(
                      (child) =>
                          !child.isInvalidItemMsg &&
                          validProductsCfn.includes(child.cfn) &&
                          child.lotSerial.every(
                              (x) =>
                                  x.isInvalidLotSerialMsg === null &&
                                  !x.isInvalidQtyMsg
                          )
                  )
                : !item.children
        ) &&
        checkIfValidPricedItems(itemTableData) &&
        patientDetails &&
        patientDetails.hrefId.length > 0
    );
};

const getPatientDetailsInDraftOrder = (patientDetails) => {
    const patientObj = {};
    if (patientDetails.hrefId) {
        patientObj.hrefId = patientDetails.hrefId;
    }
    if (patientDetails.patientDOB) {
        // getting the previous date
        patientObj.patientDOB = convertDateToISOString(
            patientDetails.patientDOB,
            'original'
        );
    }
    if (patientDetails.patientFirstName) {
        patientObj.patientFirstName = patientDetails.patientFirstName;
    }
    if (patientDetails.patientLastName) {
        patientObj.patientLastName = patientDetails.patientLastName;
    }
    if (patientDetails.patientSex) {
        patientObj.patientSex = patientDetails.patientSex;
    }
    return patientObj;
};

const generateSingleItemObj = (item, lotSerialObj, replenData, isChildItem) => {
    const singleItemObj = {
        productCFN: item.cfn,
        salesOrg: item.salesOrg,
        isReplenish: false,
    };
    if (!isChildItem) {
        if (getTotalOtherQuantity(item.lotSerial) !== null) {
            singleItemObj.otherQuantity = getTotalOtherQuantity(
                item.lotSerial
            ).toString();
        }
        singleItemObj.isAccountOwned = item.accountOwned;
        singleItemObj.unitPrice = item.basePrice;
        singleItemObj.isAdditionalCartEntry = false;
    }
    if (
        replenData &&
        replenData.length > 0 &&
        replenData.map((x) => x.cfn).includes(item.cfn)
    ) {
        const replenItemIdx = replenData.findIndex((x) => x.cfn === item.cfn);
        if (
            replenItemIdx >= 0 &&
            replenData[replenItemIdx].selectedAddressMethod &&
            Object.keys(replenData[replenItemIdx].selectedAddressMethod)
                .length > 0
        ) {
            singleItemObj.isReplenish = true;
            const shippingDetails =
                replenData[replenItemIdx].selectedAddressMethod;
            singleItemObj.replenishmentDetails = {};
            if (shippingDetails.Account && shippingDetails.Account.accountId) {
                singleItemObj.replenishmentDetails.accountId =
                    shippingDetails.Account.accountId;
            }
            if (
                shippingDetails.ShippingAddress &&
                shippingDetails.ShippingAddress.shippingAddressId
            ) {
                singleItemObj.replenishmentDetails.shipTo =
                    shippingDetails.ShippingAddress.shippingAddressId;
            }
            if (
                shippingDetails.ShippingMethod &&
                shippingDetails.ShippingMethod.shippingMethodId
            ) {
                singleItemObj.replenishmentDetails.shippingMethodId =
                    shippingDetails.ShippingMethod.shippingMethodId;
            }
            if (shippingDetails.ATTN) {
                singleItemObj.replenishmentDetails.attentionLine =
                    shippingDetails.ATTN;
            }
        }
    }
    if (getTotalUsedQuantity(item.lotSerial) !== null) {
        singleItemObj[isChildItem ? 'quantity' : 'usedQuantity'] =
            getTotalUsedQuantity(item.lotSerial).toString();
    }
    return singleItemObj;
};

const getProductsInDraftOrder = (itemTableData, replenData) => {
    return itemTableData.map((item) => {
        const productObj = item.lotSerial.map((lotSerialObj) =>
            generateSingleItemObj(item, lotSerialObj, replenData, false)
        );
        if (item.isBundleItem && item.children && item.children.length > 0) {
            productObj.bundleItem = item.children.map((child) =>
                child.lotSerial.map((childLotSerial) =>
                    generateSingleItemObj(
                        child,
                        childLotSerial,
                        replenData,
                        true
                    )
                )
            );
        }
        if (item.adjBasePrice) {
            productObj.overrideUnitPrice = item.adjBasePrice;
        }
        return productObj;
    });
};

export const createDraftOrderRequestObj = (
    usageDetails,
    patientDetails,
    itemTableData,
    replenishData
) => {
    let draftOrderObj = {};
    if (usageDetails && Object.keys(usageDetails).length > 0) {
        draftOrderObj.myCaseRef = usageDetails.myCaseRef;
        draftOrderObj.procedureCode = usageDetails.procedureCode;
        draftOrderObj.physicianId = usageDetails.accountId;
        draftOrderObj.isSapSubmission = true;
        draftOrderObj.isReportPayment = false;
    }
    if (patientDetails && Object.keys(patientDetails).length > 0) {
        const patientDetailsObj = getPatientDetailsInDraftOrder(patientDetails);
        if (Object.keys(patientDetailsObj).length > 0)
            draftOrderObj = { ...draftOrderObj, ...patientDetailsObj };
    }
    if (itemTableData && itemTableData.length > 0) {
        const productsArr = getProductsInDraftOrder(
            itemTableData,
            replenishData
        );
        if (productsArr.length > 0)
            draftOrderObj = { ...draftOrderObj, products: productsArr };
    }
    return draftOrderObj;
};

export const getUser = () => {
    if (checkImpersonationActive() || checkProxyActive()) {
        return sessionStorage.getItem('ProxyUserRole');
    } else {
        return sessionStorage.getItem('employeeRole');
    }
};

export const getMandatoryFields = (employeeRole, fieldValues) => {
    let mandatoryFields = {};
    CONSIGNMENT_RETURN_MANDATORY_FIELDS.find(
        (item) => item.role === employeeRole
    )?.mandatoryFields.map((item) => {
        mandatoryFields[item] = fieldValues ? fieldValues[item] : '';
    });
    return mandatoryFields;
};
